


// EmployeesPage.js
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployees } from "../../../redux/slices/adminEmployeesSlice";

const EmployeesPage = () => {
  const dispatch = useDispatch();

  const {
    employees,
    employeesLoading,
    employeesError,
    activityLoading, // optional: you can remove if not used
  } = useSelector((state) => state.adminEmployees);

  const [search, setSearch] = useState("");
  const [filterDept, setFilterDept] = useState("All");

  useEffect(() => {
    dispatch(fetchEmployees());
  }, [dispatch]);

  // Filter logic
  const filtered = employees
    .filter((e) =>
      e.name?.toLowerCase().includes(search.toLowerCase())
    )
    .filter((e) =>
      filterDept === "All" ? true : e.department === filterDept
    );

  // Loading state
  if (employeesLoading) {
    return <h2 style={{ color: "white" }}>Loading Employees...</h2>;
  }

  // Error state — now always string!
  if (employeesError) {
    return <h2 style={{ color: "red" }}>{employeesError}</h2>;
  }

  return (
    <div style={{ color: "white" }}>
      {/* HEADER */}
      <div
        style={{
          background: "linear-gradient(120deg,#0f172a,#1d4ed8,#3b82f6)",
          padding: "22px",
          borderRadius: "14px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          boxShadow: "0 20px 40px rgba(0,0,0,.6)",
          border: "1px solid #1e293b",
        }}
      >
        <div>
          <h2 style={{ margin: 0 }}>👨‍💼 Employees Management</h2>
          <p style={{ margin: 0, color: "#d1d5db" }}>
            Manage all company employees professionally
          </p>
        </div>
      </div>

      {/* STATS */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
          gap: "16px",
          marginTop: "18px",
        }}
      >
        <Stat title="Total Employees" icon="👥" value={employees.length} color="#6366f1" />
      </div>

      {/* FILTER BAR */}
      <div
        style={{
          marginTop: "14px",
          background: "#020617",
          padding: "12px",
          borderRadius: "10px",
          border: "1px solid #374151",
          display: "flex",
          gap: "10px",
          flexWrap: "wrap",
        }}
      >
        <input
          placeholder="Search employee..."
          style={input}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <select
          style={input}
          value={filterDept}
          onChange={(e) => setFilterDept(e.target.value)}
        >
          <option>All</option>
          <option>Engineering</option>
          <option>Design</option>
          <option>HR</option>
          <option>Management</option>
        </select>
      </div>

      {/* TABLE */}
      <div style={{ width: "100%", overflowX: "auto", marginTop: "10px" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            minWidth: "900px",
          }}
        >
          <thead>
            <tr>
              <Th>Name</Th>
              <Th>Emp ID</Th>
              <Th>Department</Th>
              <Th>Role</Th>
              <Th>Email</Th>
              <Th>Join Date</Th>
            </tr>
          </thead>
          <tbody>
            {filtered.length > 0 ? (
              filtered.map((e) => (
                <tr key={e.employeeId || e.id}>
                  <TdWhite>{e.name}</TdWhite>
                  <Td>{e.employeeId || "N/A"}</Td>
                  <Td>{e.department || "—"} </Td>
                  <Td>{e.designation || "—"}</Td>
                  <Td>{e.email || "—"}</Td>
                  <Td>
                    {e.dateOfJoining
                      ? new Date(e.dateOfJoining).toLocaleDateString()
                      : "—"}
                  </Td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" style={{ textAlign: "center", padding: "20px" }}>
                  ❌ No Employees Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

// --- Reusable UI Components ---
const Stat = ({ icon, title, value, color }) => (
  <div
    style={{
      background: "#020617",
      border: "1px solid #374151",
      borderRadius: "12px",
      padding: "18px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    }}
  >
    <div>
      <h3 style={{ margin: 0, color: "#9ca3af" }}>{title}</h3>
      <p style={{ margin: 0, fontSize: "28px", fontWeight: "bold" }}>{value}</p>
    </div>
    <span
      style={{
        fontSize: "32px",
        padding: "8px 12px",
        borderRadius: "10px",
        background: "#111827",
        border: `1px solid ${color}`,
      }}
    >
      {icon}
    </span>
  </div>
);

const Th = ({ children }) => (
  <th
    style={{
      textAlign: "left",
      padding: "10px",
      background: "#020617",
      borderBottom: "1px solid #374151",
      color: "#9ca3af",
    }}
  >
    {children}
  </th>
);

const Td = ({ children }) => (
  <td style={{ padding: "12px", borderBottom: "1px solid #374151" }}>
    {children}
  </td>
);

const TdWhite = ({ children }) => (
  <Td>
    <span style={{ color: "white" }}>{children}</span>
  </Td>
);

const input = {
  background: "#020617",
  color: "white",
  border: "1px solid #374151",
  padding: "10px",
  borderRadius: "6px",
  minWidth: "180px",
};

export default EmployeesPage;